import React, { Component } from 'react';
import { Input, Form, Row, Col, Modal, DatePicker,message, Select, Button, Checkbox } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import moment from 'moment';

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};


class AddOrEditRegisterModalDialog extends Component {

    refreshBtnOnClicked = () => {
        const {
            startDate,
            endDate,
        } = this.props.registerQueryFields;
        this.props.loadRegisterInfo({startDate,endDate});
    }

    getActionFromMode(mode) {
        if(mode === 'ADD') {
            return 'Add';
        } else if(mode === 'COPY') {
            return 'Copy';
        } else {
            return 'Edit';
        }
    }
    
    componentDidUpdate() {
        const {
            addOrEditRegisterStatus,
        } = this.props;
        const {
            mode,
        } = this.props.addOrEditRegisterModal;

        if(addOrEditRegisterStatus === ACTION_STATUS.SUCCESS) {
            const msg = this.getActionFromMode(mode) + ' Reporting Summary succeeded.';
            message.success(msg);
            this.props.initSubmitSaveRegisterActionStatus();
            this.props.resetSubmitSaveRegisterModal();
            this.refreshBtnOnClicked();
        }
        if(addOrEditRegisterStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitSaveRegisterActionStatus();
        }

    }


    onInputChange = ({name, value}) => {
        this.props.addOrEditRegisterChangeInput({name, value});
    }
    onFrequencyInputChange = (value) => {
        this.onInputChange({name: 'frequency', value: value});
        this.onInputChange({name: 'deadline', value: undefined});
        this.clearDecomposedDeadline();
        this.onInputChange({name: 'notification', value: undefined});
    }
    onDeadlineNAInputChange = (value) => {
        const deadline = !!value ? 'NA' : undefined;
        this.onInputChange({name: 'deadline', value: deadline});
        this.clearDecomposedDeadline();
        // deadline是NA时，notification必须是NA，其他情况，清空notification重新填写
        this.onInputChange({name: 'notification', value: deadline});
        
    }
    onDeadlineEveryWorkdayInputChange = (value) => {
        const deadline = !!value ? 'EveryWorkday' : undefined;
        this.onInputChange({name: 'deadline', value: deadline});
    }
    onDeadlineEndOfMonthInputChange = (value) => {
        const deadline = !!value ? 'EndOfMonth' : undefined;
        this.onInputChange({name: 'deadline', value: deadline});
    }
    onDeadlineMonthInputChange = (value) => {
        this.onInputChange({name: 'deadlineDate', value: undefined});
        this.onInputChange({name: 'deadlineMonth', value: value});
    }
    // 清空分解后的deadline的各参数
    clearDecomposedDeadline = () => {
        this.onInputChange({name: 'deadlineMonth', value: undefined});
        this.onInputChange({name: 'deadlineDate', value: undefined});
        this.onInputChange({name: 'deadlineYear', value: undefined});
    }
    onNotificationNAInputChange = (value) => {
        const notification = !!value ? 'NA' : undefined;
        this.onInputChange({name: 'notification', value: notification});
    }
    onEmailInputChange = ({name, value}) => {
        let emailStr = '';
        if(!!value) {
            value.forEach((e) => {
                if(!!emailStr) {
                    emailStr += ';';
                }
                emailStr += e;
            });
        }
        this.onInputChange({name, value: emailStr});
    }

    submitSaveAndSendRegisterModal(){
        this.onInputChange({name: 'sendmail', value: 'true'});
        this.submitSaveRegisterModal();
    }


    submitSaveRegisterModal = () => {
        const {
            mode,
        } = this.props.addOrEditRegisterModal;
        const {
            id,
            name,
            regulator,
            license,
            licenseNo,
            applicationStatus,
            licensingStatus, 
            licensedDate, 
            validTo, 
            examinationStatus, 
            examinationDeadline, 
            deregistrationDate,
            remarks,
            comments,
            sendmail,
            formGuid,

        } = this.props.addOrEditRegisterModal.fields;


        this.props.form.validateFields((err) => {
            if(err) {
                return;
            }
            // 执行提交
            this.props.submitSaveRegister({
                id,
                name,
                regulator,
                license,
                licenseNo,
                applicationStatus,
                licensingStatus, 
                licensedDate, 
                validTo, 
                examinationStatus, 
                examinationDeadline, 
                deregistrationDate,
                remarks,
                comments,
                mode,
                sendmail,
                formGuid,
            });

        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;

        const {
 
            addOrEditRegisterModal,
            addOrEditRegisterStatus,
            userAccountEmailOptions,
            userAccountOptions,
            departmentOptions,
            officeOptions,
            statusOptions, 
            licensingFormOptions,
            importanceOptions,

            regulatorOptions,
            licenseOptions,
            applicationStatusOptions,
            licensingStatusOptions,
            examinationStatusOptions,


        } = this.props;

        const {
            isOpened,
            mode,
            respErrMsg,
        } = addOrEditRegisterModal;

        const {
            id,
            name,
            regulator,
            license,
            licenseNo,
            applicationStatus,
            licensingStatus, 
            licensedDate, 
            validTo, 
            examinationStatus, 
            examinationDeadline, 
            deregistrationDate,



            department,
            office,
            status,
            lastConfirmDate,
            terminationDate,
            formGuid,
            remarks,
            comments,


        } = addOrEditRegisterModal.fields;

        // const emailToArray = !emailTo ? [] : emailTo.split(';');


        const monthDateOptions = [];


        const startYearOptions = [];



        const modalTitle = this.getActionFromMode(mode) + ' Personal Info';
        const isSubmitLoading = addOrEditRegisterStatus === ACTION_STATUS.LOGINING;
        const licensedDateMent = !licensedDate ? undefined : moment(licensedDate);
        const validToMent = !validTo ? undefined : moment(validTo);
        const examinationDeadlineMent = !examinationDeadline ? undefined : moment(examinationDeadline);
        const deregistrationDateMent = !deregistrationDate ? undefined : moment(deregistrationDate);
        // const enddatement = !enddate ? undefined : moment(enddate);

        
        return (
            <div>
                <Modal
                    title={modalTitle}
                    centered
                    width={1200}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetSubmitSaveRegisterModal()}
                    footer={[
                        <Button key="Cancel" onClick={() => this.props.resetSubmitSaveRegisterModal() }>
                          Cancel
                        </Button>,
                        <Button key="Save" type="primary" loading={isSubmitLoading} onClick={() => this.submitSaveRegisterModal() }>
                          Save
                        </Button>, 
                        <Button key="Save" type="primary" loading={isSubmitLoading} onClick={() => this.submitSaveAndSendRegisterModal() }>
                          Send
                        </Button>,
                    ]}
                >
                    <Form layout="horizontal">
                    <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Form Name">
                                    {getFieldDecorator('Form Name', {
                                        initialValue: formGuid,
                                        rules: [{
                                            required: true,
                                            message: 'Please select Form Name',
                                        }],
                                        })(
                                        <Select
                                            showSearch
                                            allowClear
                                            style={{ width: 300, marginLeft: 10 }}
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'formGuid', value: val })
                                            }} 
                                            placeholder="Please select Form Name">
                                                {licensingFormOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Name">
                                    {getFieldDecorator('Name', {
                                        initialValue: name,
                                        rules: [{
                                            required: true,
                                            message: 'Please select Name',
                                        }],
                                        })(
                                        <Select
                                            showSearch
                                            allowClear
                                            style={{ width: 300, marginLeft: 10 }}
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'name', value: val })
                                            }} 
                                            placeholder="Please select Name">
                                                {userAccountOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Regulator">
                                    {getFieldDecorator('regulator', {
                                        initialValue: regulator,
                                        rules: [{
                                            required: true,
                                            message: 'Please select Regulator',
                                        }],
                                        })(
                                        <Select
                                            allowClear
                                            style={{ width: 300, marginLeft: 10 }}
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'regulator', value: val })
                                            }} 
                                            placeholder="Please select Regulator">
                                                {regulatorOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            {/* <Col span={12}>
                                <FormItem {...formItemLayout} label="Department">
                                    {getFieldDecorator('department', {
                                        initialValue: department,
                                        rules: [{
                                            required: true,
                                            message: 'Please select Department',
                                        }],
                                        })(
                                        <Select
                                            allowClear
                                            style={{ width: 300, marginLeft: 10 }}
                                            onChange={(val) => {
                                                this.onInputChange({ name: 'department', value: val })
                                            }} 
                                            placeholder="Please select Department">
                                                {departmentOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col> */}
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                            <FormItem {...formItemLayout} label="License">
                                        {getFieldDecorator('License', {
                                            initialValue: license,
                                            rules: [{
                                                required: false,
                                                message: '',
                                            }],
                                            })(
                                            <Select 
                                                allowClear
                                                // mode='multiple'
                                                style={{ width: 300, marginLeft: 10 }}
                                                placeholder='Please select License' 
                                                onChange={(val) => {
                                                    this.onInputChange({ name: 'license', value: val })
                                            }}>
                                                {licenseOptions}
                                            </Select>
                                        )}
                                    </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="License no">
                                        {getFieldDecorator('licenseNo', {
                                            initialValue: licenseNo,
                                            rules: [{
                                                required: false,
                                                message: '',
                                            }],
                                            })(
                                            <TextArea 
                                                style={{ width: 300, marginLeft: 10 }}
                                                rows={3} 
                                                onChange={(e) => {
                                                    this.onInputChange({ name: 'licenseNo', value: e.target.value })
                                            }}/>
                                        )}
                                </FormItem>
                            </Col>
                        </Row>










                        <Row gutter={24}>
                            <Col span={12}>
                            <FormItem {...formItemLayout} label="Licensing Status">
                                {getFieldDecorator('licensingStatus ', {
                                    initialValue: licensingStatus,
                                    rules: [{
                                        required: false,
                                        message: '',
                                    }],
                                    })(
                                    <Select 
                                        allowClear
                                        // mode='multiple'
                                        style={{ width: 300, marginLeft: 10 }}
                                        placeholder='Please select Licensing Status' 
                                        onChange={(val) => {
                                            this.onInputChange({ name: 'licensingStatus', value: val })
                                    }}>
                                        {licensingStatusOptions}
                                    </Select>
                                )}
                            </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Licensed date">
                                {getFieldDecorator('licensedDate', {
                                    initialValue: licensedDateMent ,
                                    rules: [{
                                        required: false,
                                        message: 'Please select Last Confirm date ',
                                    }],
                                    })(
                                    <DatePicker 
                                        style={{ width: 300, marginLeft: 10 }}
                                        onChange={(date, dateString) => {
                                            this.onInputChange({ name: 'licensedDate', value: dateString })
                                        }}
                                    />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>



                        <Row gutter={24}>
                            <Col span={12}>
                            <FormItem {...formItemLayout} label="Application Status">
                                {getFieldDecorator('applicationStatus', {
                                    initialValue: applicationStatus,
                                    rules: [{
                                        required: false,
                                        message: '',
                                    }],
                                    })(
                                    <Select 
                                        allowClear
                                        // mode='multiple'
                                        style={{ width: 300, marginLeft: 10 }}
                                        placeholder='Please select Application Status' 
                                        onChange={(val) => {
                                            this.onInputChange({ name: 'applicationStatus', value: val })
                                    }}>
                                        {applicationStatusOptions}
                                    </Select>
                                )}
                            </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Valid to">
                                {getFieldDecorator('validTo', {
                                    initialValue: validToMent,
                                    rules: [{
                                        required: false,
                                        message: 'Please select Valid to',
                                    }],
                                    })(
                                    <DatePicker 
                                        style={{ width: 300, marginLeft: 10 }}
                                        onChange={(date, dateString) => {
                                            this.onInputChange({ name: 'validTo', value: dateString })
                                        }}
                                    />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Examination Status">
                                {getFieldDecorator('examinationStatus', {
                                    initialValue: examinationStatus,
                                    rules: [{
                                        required: false,
                                        message: '',
                                    }],
                                    })(
                                    <Select 
                                        allowClear
                                        // mode='multiple'
                                        style={{ width: 300, marginLeft: 10 }}
                                        placeholder='Please select Examination Status' 
                                        onChange={(val) => {
                                            this.onInputChange({ name: 'examinationStatus', value: val })
                                    }}>
                                        {examinationStatusOptions}
                                    </Select>
                                )}
                            </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Examination Deadline">
                                {getFieldDecorator('examinationDeadline', {
                                    initialValue: examinationDeadlineMent ,
                                    rules: [{
                                        required: false,
                                        message: 'Please select Examination Deadline',
                                    }],
                                    })(
                                    <DatePicker 
                                        style={{ width: 300, marginLeft: 10 }}
                                        onChange={(date, dateString) => {
                                            this.onInputChange({ name: 'examinationDeadline', value: dateString })
                                        }}
                                    />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Deregistration Date">
                                {getFieldDecorator('deregistrationDate', {
                                    initialValue: deregistrationDateMent,
                                    rules: [{
                                        required: false,
                                        message: 'Please select Deregistration Date',
                                    }],
                                    })(
                                    <DatePicker 
                                        style={{ width: 300, marginLeft: 10 }}
                                        onChange={(date, dateString) => {
                                            this.onInputChange({ name: 'deregistrationDate', value: dateString })
                                        }}
                                    />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="comments">
                                    {getFieldDecorator('comments', {
                                        initialValue: comments,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 300, marginLeft: 10 }}
                                            rows={3} 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'comments', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="remarks">
                                    {getFieldDecorator('remarks', {
                                        initialValue: remarks,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 300, marginLeft: 10 }}
                                            rows={3} 
                                            onChange={(e) => {
                                                this.onInputChange({ name: 'remarks', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>


                    </Form>
                    {
                        !!respErrMsg &&  
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{ respErrMsg }</p>
                        </Message>
                    }

                </Modal>
            </div>
        );
    }
}


const AddOrEditRegisterModalDialogForm = Form.create({ name: 'AddOrEditRegisterModalDialog' })(AddOrEditRegisterModalDialog);

export default AddOrEditRegisterModalDialogForm;
